import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var font = variables.font,
  global = variables.global;
var colors = tokens.colors;
export var anchor = /*#__PURE__*/css("border:0;outline:none;padding:0;vertical-align:top;height:24px;cursor:pointer;white-space:nowrap;color:", colors.neutral.heavy.default, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";background:none;");
export var icon = /*#__PURE__*/css("width:18px;height:18px;position:relative;top:-1px;margin-left:5px;color:", colors.neutral.medium.default, ";");
export var dropdown = /*#__PURE__*/css("z-index:", global.layerPopout, ";");